import { useContext } from 'react'

import AnswerStreamCtx from '@/contexts/AnswerStreamContext'

export default function useAnswerStreamContext() {
  return useContext(AnswerStreamCtx)
}
